import {Component} from '@angular/core';

@Component({
    selector: 'cms-page-not-found',
    templateUrl: 'page-not-found.component.html'
})

export class CmsPageNotFoundComponent {}
